export default __webpack_public_path__ + "static/media/IBMPlexSans-Medium-Latin1.5e6c7e1b.woff2";